(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noire-header-language"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noire-language-menu')) {
  customElements.define('noire-language-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.querySelector('details').open = false;
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.querySelector('details').open) {
          event.preventDefault();
          event.stopPropagation();
          this.querySelector('details').open = false;
          this.querySelector('summary').focus();
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
